import { ApiService, type ApiRequestConfig } from "./api.service";
import type {
  TAdminTeammate,
  TAdminTeammatesScreen,
  TAdminTeammateUpdate,
  TMemberTeammate,
  TMemberTeammatesScreen,
  TMemberTeammateUpdate,
} from "@/types/teammates";

/**
 * The Digital Teammates settings endpoints (NG-2622): the admin's grant per
 * teammate (gated on `workspace.edit`) and the caller's own instance (any
 * member of the workspace).
 */
export class WorkspaceTeammatesService extends ApiService {
  async getAdminScreen(slug: string, config?: ApiRequestConfig): Promise<TAdminTeammatesScreen> {
    return this.get(`/api/workspaces/${slug}/teammates/`, config);
  }

  /** Switch a teammate on or off for the workspace. Switching it on, or saving
   *  it while on, records the admin's consent to its current version. */
  async updateGrant(
    slug: string,
    teammateSlug: string,
    data: TAdminTeammateUpdate,
  ): Promise<TAdminTeammate> {
    return this.put(`/api/workspaces/${slug}/teammates/${teammateSlug}/`, data);
  }

  async getMemberScreen(slug: string, config?: ApiRequestConfig): Promise<TMemberTeammatesScreen> {
    return this.get(`/api/workspaces/${slug}/teammates/mine/`, config);
  }

  /** Turn the caller's own teammate on (consenting to `consent_version`) or off. */
  async updateMine(
    slug: string,
    teammateSlug: string,
    data: TMemberTeammateUpdate,
  ): Promise<TMemberTeammate> {
    return this.put(`/api/workspaces/${slug}/teammates/${teammateSlug}/mine/`, data);
  }
}
